import { Maybe } from '../../../__generated__/globalTypes'

import { Amount, isAmount } from './Amount'

import {
  PlanFeatureFragment,
  isPlanFeatureFragment,
} from './PlanFeatureFragment'

import planFragmentRawString from '../PlanFragment.graphql'

export const planFragmentString = planFragmentRawString

export type PlanFragment = {
  id: string
  title: string
  subtitle: Maybe<string>
  isLegacy: boolean
  isLimited: boolean
  color: Maybe<string>
  stripeId: string
  backgroundStartColor: string
  backgroundEndColor: string
  backgroundImageUrl: Maybe<string>
  price: Amount
  features: PlanFeatureFragment[]
}

export const isPlanFragment = (fragment: any): fragment is PlanFragment =>
  fragment &&
  typeof fragment.id === 'string' &&
  typeof fragment.title === 'string' &&
  (fragment.subtitle === null || typeof fragment.subtitle === 'string') &&
  typeof fragment.isLegacy === 'boolean' &&
  typeof fragment.isLimited === 'boolean' &&
  (fragment.color === null || typeof fragment.color === 'string') &&
  typeof fragment.stripeId === 'string' &&
  typeof fragment.backgroundStartColor === 'string' &&
  typeof fragment.backgroundEndColor === 'string' &&
  (fragment.backgroundImageUrl === null ||
    typeof fragment.backgroundImageUrl === 'string') &&
  (isAmount(fragment.price) as boolean) &&
  Array.isArray(fragment.features) &&
  fragment.features
    .slice(0, 5)
    .reduce(
      (accum: any, next: any) =>
        accum && (isPlanFeatureFragment(next) as boolean),
      true,
    )
